export default __webpack_public_path__ + "static/media/default.bde4f682.svg";